export const environment = {
  production: false,
  clientId: 'b4806d5e-1b81-48d2-a174-cc45ae686747',
  issuer: 'https://auth-i.bmwgroup.net:443/auth/oauth2/realms/root/realms/internetb2x',
  apiBaseUrl: 'https://crossborder-api-oasis-oasiszadev-mnng.scp.eu-central-1.aws.cloud.bmw/',
  externalLinks: {
    unitOverview: 'https://unitoverview-ui-oasis-oasiszadev-mnng.scp.eu-central-1.aws.cloud.bmw?vin='
  }
};
export const AuthConfig = {
  AMBaseURL: 'https://auth-i.bmwgroup.net/auth',
  realmPath: 'realms/root/realms/internetb2x',
  clientId: 'b4806d5e-1b81-48d2-a174-cc45ae686747',
  redirectUri: 'https://oasis-cb-int.bmwgroup.com',
  state: 'myappstate',
  nonce: '123456789',
  scopes: 'openid%20profile%20email%20organization',
};
